__turbopack_context__.v({
  "closeBtn": "WWindowBanner-module__6b0wUa__closeBtn",
  "dialog": "WWindowBanner-module__6b0wUa__dialog",
  "dot": "WWindowBanner-module__6b0wUa__dot",
  "dotActive": "WWindowBanner-module__6b0wUa__dotActive",
  "dots": "WWindowBanner-module__6b0wUa__dots",
  "empty": "WWindowBanner-module__6b0wUa__empty",
  "image": "WWindowBanner-module__6b0wUa__image",
  "layer": "WWindowBanner-module__6b0wUa__layer",
  "layerActive": "WWindowBanner-module__6b0wUa__layerActive",
  "link": "WWindowBanner-module__6b0wUa__link",
  "overlay": "WWindowBanner-module__6b0wUa__overlay",
  "root": "WWindowBanner-module__6b0wUa__root",
  "stage": "WWindowBanner-module__6b0wUa__stage",
  "text": "WWindowBanner-module__6b0wUa__text",
  "wbannerFadeIn": "WWindowBanner-module__6b0wUa__wbannerFadeIn",
});
